/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from "./routes/__root";
import { Route as LoginImport } from "./routes/login";
import { Route as AuthenticatedImport } from "./routes/_authenticated";
import { Route as AuthenticatedIndexImport } from "./routes/_authenticated/index";
import { Route as AuthenticatedProfileImport } from "./routes/_authenticated/profile";
import { Route as AuthenticatedTeachersIndexImport } from "./routes/_authenticated/teachers/index";
import { Route as AuthenticatedStudentsIndexImport } from "./routes/_authenticated/students/index";
import { Route as AuthenticatedReportsIndexImport } from "./routes/_authenticated/reports/index";
import { Route as AuthenticatedPaymentsIndexImport } from "./routes/_authenticated/payments/index";
import { Route as AuthenticatedAdminsIndexImport } from "./routes/_authenticated/admins/index";
import { Route as AuthenticatedTeachersNewImport } from "./routes/_authenticated/teachers/new";
import { Route as AuthenticatedStudentsNewImport } from "./routes/_authenticated/students/new";
import { Route as AuthenticatedPaymentsNewImport } from "./routes/_authenticated/payments/new";
import { Route as AuthenticatedPaymentsPaymentIdImport } from "./routes/_authenticated/payments/$paymentId";
import { Route as AuthenticatedAdminsNewImport } from "./routes/_authenticated/admins/new";
import { Route as AuthenticatedAdminsAdminIdImport } from "./routes/_authenticated/admins/$adminId";
import { Route as AuthenticatedTeachersTeacherIdIndexImport } from "./routes/_authenticated/teachers/$teacherId/index";
import { Route as AuthenticatedStudentsStudentIdIndexImport } from "./routes/_authenticated/students/$studentId/index";
import { Route as AuthenticatedTeachersTeacherIdProfileImport } from "./routes/_authenticated/teachers/$teacherId/profile";
import { Route as AuthenticatedTeachersTeacherIdEditImport } from "./routes/_authenticated/teachers/$teacherId/edit";
import { Route as AuthenticatedStudentsStudentIdProfileImport } from "./routes/_authenticated/students/$studentId/profile";
import { Route as AuthenticatedStudentsStudentIdEditImport } from "./routes/_authenticated/students/$studentId/edit";
import { Route as AuthenticatedReportsDetailedViewTeacherAssignmentByLocationCenterIdImport } from "./routes/_authenticated/reports/detailed-view/teacher-assignment-by-location/$centerId";
import { Route as AuthenticatedReportsDetailedViewStudentCountByTeacherTeacherIdImport } from "./routes/_authenticated/reports/detailed-view/student-count-by-teacher/$teacherId";
import { Route as AuthenticatedReportsDetailedViewMonthlyStudentRegistrationsDateImport } from "./routes/_authenticated/reports/detailed-view/monthly-student-registrations/$date";

// Create/Update Routes

const LoginRoute = LoginImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRoute,
} as any);

const AuthenticatedRoute = AuthenticatedImport.update({
  id: "/_authenticated",
  getParentRoute: () => rootRoute,
} as any);

const AuthenticatedIndexRoute = AuthenticatedIndexImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthenticatedRoute,
} as any);

const AuthenticatedProfileRoute = AuthenticatedProfileImport.update({
  id: "/profile",
  path: "/profile",
  getParentRoute: () => AuthenticatedRoute,
} as any);

const AuthenticatedTeachersIndexRoute = AuthenticatedTeachersIndexImport.update(
  {
    id: "/teachers/",
    path: "/teachers/",
    getParentRoute: () => AuthenticatedRoute,
  } as any,
);

const AuthenticatedStudentsIndexRoute = AuthenticatedStudentsIndexImport.update(
  {
    id: "/students/",
    path: "/students/",
    getParentRoute: () => AuthenticatedRoute,
  } as any,
);

const AuthenticatedReportsIndexRoute = AuthenticatedReportsIndexImport.update({
  id: "/reports/",
  path: "/reports/",
  getParentRoute: () => AuthenticatedRoute,
} as any);

const AuthenticatedPaymentsIndexRoute = AuthenticatedPaymentsIndexImport.update(
  {
    id: "/payments/",
    path: "/payments/",
    getParentRoute: () => AuthenticatedRoute,
  } as any,
);

const AuthenticatedAdminsIndexRoute = AuthenticatedAdminsIndexImport.update({
  id: "/admins/",
  path: "/admins/",
  getParentRoute: () => AuthenticatedRoute,
} as any);

const AuthenticatedTeachersNewRoute = AuthenticatedTeachersNewImport.update({
  id: "/teachers/new",
  path: "/teachers/new",
  getParentRoute: () => AuthenticatedRoute,
} as any);

const AuthenticatedStudentsNewRoute = AuthenticatedStudentsNewImport.update({
  id: "/students/new",
  path: "/students/new",
  getParentRoute: () => AuthenticatedRoute,
} as any);

const AuthenticatedPaymentsNewRoute = AuthenticatedPaymentsNewImport.update({
  id: "/payments/new",
  path: "/payments/new",
  getParentRoute: () => AuthenticatedRoute,
} as any);

const AuthenticatedPaymentsPaymentIdRoute =
  AuthenticatedPaymentsPaymentIdImport.update({
    id: "/payments/$paymentId",
    path: "/payments/$paymentId",
    getParentRoute: () => AuthenticatedRoute,
  } as any);

const AuthenticatedAdminsNewRoute = AuthenticatedAdminsNewImport.update({
  id: "/admins/new",
  path: "/admins/new",
  getParentRoute: () => AuthenticatedRoute,
} as any);

const AuthenticatedAdminsAdminIdRoute = AuthenticatedAdminsAdminIdImport.update(
  {
    id: "/admins/$adminId",
    path: "/admins/$adminId",
    getParentRoute: () => AuthenticatedRoute,
  } as any,
);

const AuthenticatedTeachersTeacherIdIndexRoute =
  AuthenticatedTeachersTeacherIdIndexImport.update({
    id: "/teachers/$teacherId/",
    path: "/teachers/$teacherId/",
    getParentRoute: () => AuthenticatedRoute,
  } as any);

const AuthenticatedStudentsStudentIdIndexRoute =
  AuthenticatedStudentsStudentIdIndexImport.update({
    id: "/students/$studentId/",
    path: "/students/$studentId/",
    getParentRoute: () => AuthenticatedRoute,
  } as any);

const AuthenticatedTeachersTeacherIdProfileRoute =
  AuthenticatedTeachersTeacherIdProfileImport.update({
    id: "/teachers/$teacherId/profile",
    path: "/teachers/$teacherId/profile",
    getParentRoute: () => AuthenticatedRoute,
  } as any);

const AuthenticatedTeachersTeacherIdEditRoute =
  AuthenticatedTeachersTeacherIdEditImport.update({
    id: "/teachers/$teacherId/edit",
    path: "/teachers/$teacherId/edit",
    getParentRoute: () => AuthenticatedRoute,
  } as any);

const AuthenticatedStudentsStudentIdProfileRoute =
  AuthenticatedStudentsStudentIdProfileImport.update({
    id: "/students/$studentId/profile",
    path: "/students/$studentId/profile",
    getParentRoute: () => AuthenticatedRoute,
  } as any);

const AuthenticatedStudentsStudentIdEditRoute =
  AuthenticatedStudentsStudentIdEditImport.update({
    id: "/students/$studentId/edit",
    path: "/students/$studentId/edit",
    getParentRoute: () => AuthenticatedRoute,
  } as any);

const AuthenticatedReportsDetailedViewTeacherAssignmentByLocationCenterIdRoute =
  AuthenticatedReportsDetailedViewTeacherAssignmentByLocationCenterIdImport.update(
    {
      id: "/reports/detailed-view/teacher-assignment-by-location/$centerId",
      path: "/reports/detailed-view/teacher-assignment-by-location/$centerId",
      getParentRoute: () => AuthenticatedRoute,
    } as any,
  );

const AuthenticatedReportsDetailedViewStudentCountByTeacherTeacherIdRoute =
  AuthenticatedReportsDetailedViewStudentCountByTeacherTeacherIdImport.update({
    id: "/reports/detailed-view/student-count-by-teacher/$teacherId",
    path: "/reports/detailed-view/student-count-by-teacher/$teacherId",
    getParentRoute: () => AuthenticatedRoute,
  } as any);

const AuthenticatedReportsDetailedViewMonthlyStudentRegistrationsDateRoute =
  AuthenticatedReportsDetailedViewMonthlyStudentRegistrationsDateImport.update({
    id: "/reports/detailed-view/monthly-student-registrations/$date",
    path: "/reports/detailed-view/monthly-student-registrations/$date",
    getParentRoute: () => AuthenticatedRoute,
  } as any);

// Populate the FileRoutesByPath interface

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_authenticated": {
      id: "/_authenticated";
      path: "";
      fullPath: "";
      preLoaderRoute: typeof AuthenticatedImport;
      parentRoute: typeof rootRoute;
    };
    "/login": {
      id: "/login";
      path: "/login";
      fullPath: "/login";
      preLoaderRoute: typeof LoginImport;
      parentRoute: typeof rootRoute;
    };
    "/_authenticated/profile": {
      id: "/_authenticated/profile";
      path: "/profile";
      fullPath: "/profile";
      preLoaderRoute: typeof AuthenticatedProfileImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/": {
      id: "/_authenticated/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof AuthenticatedIndexImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/admins/$adminId": {
      id: "/_authenticated/admins/$adminId";
      path: "/admins/$adminId";
      fullPath: "/admins/$adminId";
      preLoaderRoute: typeof AuthenticatedAdminsAdminIdImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/admins/new": {
      id: "/_authenticated/admins/new";
      path: "/admins/new";
      fullPath: "/admins/new";
      preLoaderRoute: typeof AuthenticatedAdminsNewImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/payments/$paymentId": {
      id: "/_authenticated/payments/$paymentId";
      path: "/payments/$paymentId";
      fullPath: "/payments/$paymentId";
      preLoaderRoute: typeof AuthenticatedPaymentsPaymentIdImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/payments/new": {
      id: "/_authenticated/payments/new";
      path: "/payments/new";
      fullPath: "/payments/new";
      preLoaderRoute: typeof AuthenticatedPaymentsNewImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/students/new": {
      id: "/_authenticated/students/new";
      path: "/students/new";
      fullPath: "/students/new";
      preLoaderRoute: typeof AuthenticatedStudentsNewImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/teachers/new": {
      id: "/_authenticated/teachers/new";
      path: "/teachers/new";
      fullPath: "/teachers/new";
      preLoaderRoute: typeof AuthenticatedTeachersNewImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/admins/": {
      id: "/_authenticated/admins/";
      path: "/admins";
      fullPath: "/admins";
      preLoaderRoute: typeof AuthenticatedAdminsIndexImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/payments/": {
      id: "/_authenticated/payments/";
      path: "/payments";
      fullPath: "/payments";
      preLoaderRoute: typeof AuthenticatedPaymentsIndexImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/reports/": {
      id: "/_authenticated/reports/";
      path: "/reports";
      fullPath: "/reports";
      preLoaderRoute: typeof AuthenticatedReportsIndexImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/students/": {
      id: "/_authenticated/students/";
      path: "/students";
      fullPath: "/students";
      preLoaderRoute: typeof AuthenticatedStudentsIndexImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/teachers/": {
      id: "/_authenticated/teachers/";
      path: "/teachers";
      fullPath: "/teachers";
      preLoaderRoute: typeof AuthenticatedTeachersIndexImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/students/$studentId/edit": {
      id: "/_authenticated/students/$studentId/edit";
      path: "/students/$studentId/edit";
      fullPath: "/students/$studentId/edit";
      preLoaderRoute: typeof AuthenticatedStudentsStudentIdEditImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/students/$studentId/profile": {
      id: "/_authenticated/students/$studentId/profile";
      path: "/students/$studentId/profile";
      fullPath: "/students/$studentId/profile";
      preLoaderRoute: typeof AuthenticatedStudentsStudentIdProfileImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/teachers/$teacherId/edit": {
      id: "/_authenticated/teachers/$teacherId/edit";
      path: "/teachers/$teacherId/edit";
      fullPath: "/teachers/$teacherId/edit";
      preLoaderRoute: typeof AuthenticatedTeachersTeacherIdEditImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/teachers/$teacherId/profile": {
      id: "/_authenticated/teachers/$teacherId/profile";
      path: "/teachers/$teacherId/profile";
      fullPath: "/teachers/$teacherId/profile";
      preLoaderRoute: typeof AuthenticatedTeachersTeacherIdProfileImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/students/$studentId/": {
      id: "/_authenticated/students/$studentId/";
      path: "/students/$studentId";
      fullPath: "/students/$studentId";
      preLoaderRoute: typeof AuthenticatedStudentsStudentIdIndexImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/teachers/$teacherId/": {
      id: "/_authenticated/teachers/$teacherId/";
      path: "/teachers/$teacherId";
      fullPath: "/teachers/$teacherId";
      preLoaderRoute: typeof AuthenticatedTeachersTeacherIdIndexImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/reports/detailed-view/monthly-student-registrations/$date": {
      id: "/_authenticated/reports/detailed-view/monthly-student-registrations/$date";
      path: "/reports/detailed-view/monthly-student-registrations/$date";
      fullPath: "/reports/detailed-view/monthly-student-registrations/$date";
      preLoaderRoute: typeof AuthenticatedReportsDetailedViewMonthlyStudentRegistrationsDateImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/reports/detailed-view/student-count-by-teacher/$teacherId": {
      id: "/_authenticated/reports/detailed-view/student-count-by-teacher/$teacherId";
      path: "/reports/detailed-view/student-count-by-teacher/$teacherId";
      fullPath: "/reports/detailed-view/student-count-by-teacher/$teacherId";
      preLoaderRoute: typeof AuthenticatedReportsDetailedViewStudentCountByTeacherTeacherIdImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/reports/detailed-view/teacher-assignment-by-location/$centerId": {
      id: "/_authenticated/reports/detailed-view/teacher-assignment-by-location/$centerId";
      path: "/reports/detailed-view/teacher-assignment-by-location/$centerId";
      fullPath: "/reports/detailed-view/teacher-assignment-by-location/$centerId";
      preLoaderRoute: typeof AuthenticatedReportsDetailedViewTeacherAssignmentByLocationCenterIdImport;
      parentRoute: typeof AuthenticatedImport;
    };
  }
}

// Create and export the route tree

interface AuthenticatedRouteChildren {
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRoute;
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute;
  AuthenticatedAdminsAdminIdRoute: typeof AuthenticatedAdminsAdminIdRoute;
  AuthenticatedAdminsNewRoute: typeof AuthenticatedAdminsNewRoute;
  AuthenticatedPaymentsPaymentIdRoute: typeof AuthenticatedPaymentsPaymentIdRoute;
  AuthenticatedPaymentsNewRoute: typeof AuthenticatedPaymentsNewRoute;
  AuthenticatedStudentsNewRoute: typeof AuthenticatedStudentsNewRoute;
  AuthenticatedTeachersNewRoute: typeof AuthenticatedTeachersNewRoute;
  AuthenticatedAdminsIndexRoute: typeof AuthenticatedAdminsIndexRoute;
  AuthenticatedPaymentsIndexRoute: typeof AuthenticatedPaymentsIndexRoute;
  AuthenticatedReportsIndexRoute: typeof AuthenticatedReportsIndexRoute;
  AuthenticatedStudentsIndexRoute: typeof AuthenticatedStudentsIndexRoute;
  AuthenticatedTeachersIndexRoute: typeof AuthenticatedTeachersIndexRoute;
  AuthenticatedStudentsStudentIdEditRoute: typeof AuthenticatedStudentsStudentIdEditRoute;
  AuthenticatedStudentsStudentIdProfileRoute: typeof AuthenticatedStudentsStudentIdProfileRoute;
  AuthenticatedTeachersTeacherIdEditRoute: typeof AuthenticatedTeachersTeacherIdEditRoute;
  AuthenticatedTeachersTeacherIdProfileRoute: typeof AuthenticatedTeachersTeacherIdProfileRoute;
  AuthenticatedStudentsStudentIdIndexRoute: typeof AuthenticatedStudentsStudentIdIndexRoute;
  AuthenticatedTeachersTeacherIdIndexRoute: typeof AuthenticatedTeachersTeacherIdIndexRoute;
  AuthenticatedReportsDetailedViewMonthlyStudentRegistrationsDateRoute: typeof AuthenticatedReportsDetailedViewMonthlyStudentRegistrationsDateRoute;
  AuthenticatedReportsDetailedViewStudentCountByTeacherTeacherIdRoute: typeof AuthenticatedReportsDetailedViewStudentCountByTeacherTeacherIdRoute;
  AuthenticatedReportsDetailedViewTeacherAssignmentByLocationCenterIdRoute: typeof AuthenticatedReportsDetailedViewTeacherAssignmentByLocationCenterIdRoute;
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedProfileRoute: AuthenticatedProfileRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedAdminsAdminIdRoute: AuthenticatedAdminsAdminIdRoute,
  AuthenticatedAdminsNewRoute: AuthenticatedAdminsNewRoute,
  AuthenticatedPaymentsPaymentIdRoute: AuthenticatedPaymentsPaymentIdRoute,
  AuthenticatedPaymentsNewRoute: AuthenticatedPaymentsNewRoute,
  AuthenticatedStudentsNewRoute: AuthenticatedStudentsNewRoute,
  AuthenticatedTeachersNewRoute: AuthenticatedTeachersNewRoute,
  AuthenticatedAdminsIndexRoute: AuthenticatedAdminsIndexRoute,
  AuthenticatedPaymentsIndexRoute: AuthenticatedPaymentsIndexRoute,
  AuthenticatedReportsIndexRoute: AuthenticatedReportsIndexRoute,
  AuthenticatedStudentsIndexRoute: AuthenticatedStudentsIndexRoute,
  AuthenticatedTeachersIndexRoute: AuthenticatedTeachersIndexRoute,
  AuthenticatedStudentsStudentIdEditRoute:
    AuthenticatedStudentsStudentIdEditRoute,
  AuthenticatedStudentsStudentIdProfileRoute:
    AuthenticatedStudentsStudentIdProfileRoute,
  AuthenticatedTeachersTeacherIdEditRoute:
    AuthenticatedTeachersTeacherIdEditRoute,
  AuthenticatedTeachersTeacherIdProfileRoute:
    AuthenticatedTeachersTeacherIdProfileRoute,
  AuthenticatedStudentsStudentIdIndexRoute:
    AuthenticatedStudentsStudentIdIndexRoute,
  AuthenticatedTeachersTeacherIdIndexRoute:
    AuthenticatedTeachersTeacherIdIndexRoute,
  AuthenticatedReportsDetailedViewMonthlyStudentRegistrationsDateRoute:
    AuthenticatedReportsDetailedViewMonthlyStudentRegistrationsDateRoute,
  AuthenticatedReportsDetailedViewStudentCountByTeacherTeacherIdRoute:
    AuthenticatedReportsDetailedViewStudentCountByTeacherTeacherIdRoute,
  AuthenticatedReportsDetailedViewTeacherAssignmentByLocationCenterIdRoute:
    AuthenticatedReportsDetailedViewTeacherAssignmentByLocationCenterIdRoute,
};

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
);

export interface FileRoutesByFullPath {
  "": typeof AuthenticatedRouteWithChildren;
  "/login": typeof LoginRoute;
  "/profile": typeof AuthenticatedProfileRoute;
  "/": typeof AuthenticatedIndexRoute;
  "/admins/$adminId": typeof AuthenticatedAdminsAdminIdRoute;
  "/admins/new": typeof AuthenticatedAdminsNewRoute;
  "/payments/$paymentId": typeof AuthenticatedPaymentsPaymentIdRoute;
  "/payments/new": typeof AuthenticatedPaymentsNewRoute;
  "/students/new": typeof AuthenticatedStudentsNewRoute;
  "/teachers/new": typeof AuthenticatedTeachersNewRoute;
  "/admins": typeof AuthenticatedAdminsIndexRoute;
  "/payments": typeof AuthenticatedPaymentsIndexRoute;
  "/reports": typeof AuthenticatedReportsIndexRoute;
  "/students": typeof AuthenticatedStudentsIndexRoute;
  "/teachers": typeof AuthenticatedTeachersIndexRoute;
  "/students/$studentId/edit": typeof AuthenticatedStudentsStudentIdEditRoute;
  "/students/$studentId/profile": typeof AuthenticatedStudentsStudentIdProfileRoute;
  "/teachers/$teacherId/edit": typeof AuthenticatedTeachersTeacherIdEditRoute;
  "/teachers/$teacherId/profile": typeof AuthenticatedTeachersTeacherIdProfileRoute;
  "/students/$studentId": typeof AuthenticatedStudentsStudentIdIndexRoute;
  "/teachers/$teacherId": typeof AuthenticatedTeachersTeacherIdIndexRoute;
  "/reports/detailed-view/monthly-student-registrations/$date": typeof AuthenticatedReportsDetailedViewMonthlyStudentRegistrationsDateRoute;
  "/reports/detailed-view/student-count-by-teacher/$teacherId": typeof AuthenticatedReportsDetailedViewStudentCountByTeacherTeacherIdRoute;
  "/reports/detailed-view/teacher-assignment-by-location/$centerId": typeof AuthenticatedReportsDetailedViewTeacherAssignmentByLocationCenterIdRoute;
}

export interface FileRoutesByTo {
  "/login": typeof LoginRoute;
  "/profile": typeof AuthenticatedProfileRoute;
  "/": typeof AuthenticatedIndexRoute;
  "/admins/$adminId": typeof AuthenticatedAdminsAdminIdRoute;
  "/admins/new": typeof AuthenticatedAdminsNewRoute;
  "/payments/$paymentId": typeof AuthenticatedPaymentsPaymentIdRoute;
  "/payments/new": typeof AuthenticatedPaymentsNewRoute;
  "/students/new": typeof AuthenticatedStudentsNewRoute;
  "/teachers/new": typeof AuthenticatedTeachersNewRoute;
  "/admins": typeof AuthenticatedAdminsIndexRoute;
  "/payments": typeof AuthenticatedPaymentsIndexRoute;
  "/reports": typeof AuthenticatedReportsIndexRoute;
  "/students": typeof AuthenticatedStudentsIndexRoute;
  "/teachers": typeof AuthenticatedTeachersIndexRoute;
  "/students/$studentId/edit": typeof AuthenticatedStudentsStudentIdEditRoute;
  "/students/$studentId/profile": typeof AuthenticatedStudentsStudentIdProfileRoute;
  "/teachers/$teacherId/edit": typeof AuthenticatedTeachersTeacherIdEditRoute;
  "/teachers/$teacherId/profile": typeof AuthenticatedTeachersTeacherIdProfileRoute;
  "/students/$studentId": typeof AuthenticatedStudentsStudentIdIndexRoute;
  "/teachers/$teacherId": typeof AuthenticatedTeachersTeacherIdIndexRoute;
  "/reports/detailed-view/monthly-student-registrations/$date": typeof AuthenticatedReportsDetailedViewMonthlyStudentRegistrationsDateRoute;
  "/reports/detailed-view/student-count-by-teacher/$teacherId": typeof AuthenticatedReportsDetailedViewStudentCountByTeacherTeacherIdRoute;
  "/reports/detailed-view/teacher-assignment-by-location/$centerId": typeof AuthenticatedReportsDetailedViewTeacherAssignmentByLocationCenterIdRoute;
}

export interface FileRoutesById {
  __root__: typeof rootRoute;
  "/_authenticated": typeof AuthenticatedRouteWithChildren;
  "/login": typeof LoginRoute;
  "/_authenticated/profile": typeof AuthenticatedProfileRoute;
  "/_authenticated/": typeof AuthenticatedIndexRoute;
  "/_authenticated/admins/$adminId": typeof AuthenticatedAdminsAdminIdRoute;
  "/_authenticated/admins/new": typeof AuthenticatedAdminsNewRoute;
  "/_authenticated/payments/$paymentId": typeof AuthenticatedPaymentsPaymentIdRoute;
  "/_authenticated/payments/new": typeof AuthenticatedPaymentsNewRoute;
  "/_authenticated/students/new": typeof AuthenticatedStudentsNewRoute;
  "/_authenticated/teachers/new": typeof AuthenticatedTeachersNewRoute;
  "/_authenticated/admins/": typeof AuthenticatedAdminsIndexRoute;
  "/_authenticated/payments/": typeof AuthenticatedPaymentsIndexRoute;
  "/_authenticated/reports/": typeof AuthenticatedReportsIndexRoute;
  "/_authenticated/students/": typeof AuthenticatedStudentsIndexRoute;
  "/_authenticated/teachers/": typeof AuthenticatedTeachersIndexRoute;
  "/_authenticated/students/$studentId/edit": typeof AuthenticatedStudentsStudentIdEditRoute;
  "/_authenticated/students/$studentId/profile": typeof AuthenticatedStudentsStudentIdProfileRoute;
  "/_authenticated/teachers/$teacherId/edit": typeof AuthenticatedTeachersTeacherIdEditRoute;
  "/_authenticated/teachers/$teacherId/profile": typeof AuthenticatedTeachersTeacherIdProfileRoute;
  "/_authenticated/students/$studentId/": typeof AuthenticatedStudentsStudentIdIndexRoute;
  "/_authenticated/teachers/$teacherId/": typeof AuthenticatedTeachersTeacherIdIndexRoute;
  "/_authenticated/reports/detailed-view/monthly-student-registrations/$date": typeof AuthenticatedReportsDetailedViewMonthlyStudentRegistrationsDateRoute;
  "/_authenticated/reports/detailed-view/student-count-by-teacher/$teacherId": typeof AuthenticatedReportsDetailedViewStudentCountByTeacherTeacherIdRoute;
  "/_authenticated/reports/detailed-view/teacher-assignment-by-location/$centerId": typeof AuthenticatedReportsDetailedViewTeacherAssignmentByLocationCenterIdRoute;
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | ""
    | "/login"
    | "/profile"
    | "/"
    | "/admins/$adminId"
    | "/admins/new"
    | "/payments/$paymentId"
    | "/payments/new"
    | "/students/new"
    | "/teachers/new"
    | "/admins"
    | "/payments"
    | "/reports"
    | "/students"
    | "/teachers"
    | "/students/$studentId/edit"
    | "/students/$studentId/profile"
    | "/teachers/$teacherId/edit"
    | "/teachers/$teacherId/profile"
    | "/students/$studentId"
    | "/teachers/$teacherId"
    | "/reports/detailed-view/monthly-student-registrations/$date"
    | "/reports/detailed-view/student-count-by-teacher/$teacherId"
    | "/reports/detailed-view/teacher-assignment-by-location/$centerId";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/login"
    | "/profile"
    | "/"
    | "/admins/$adminId"
    | "/admins/new"
    | "/payments/$paymentId"
    | "/payments/new"
    | "/students/new"
    | "/teachers/new"
    | "/admins"
    | "/payments"
    | "/reports"
    | "/students"
    | "/teachers"
    | "/students/$studentId/edit"
    | "/students/$studentId/profile"
    | "/teachers/$teacherId/edit"
    | "/teachers/$teacherId/profile"
    | "/students/$studentId"
    | "/teachers/$teacherId"
    | "/reports/detailed-view/monthly-student-registrations/$date"
    | "/reports/detailed-view/student-count-by-teacher/$teacherId"
    | "/reports/detailed-view/teacher-assignment-by-location/$centerId";
  id:
    | "__root__"
    | "/_authenticated"
    | "/login"
    | "/_authenticated/profile"
    | "/_authenticated/"
    | "/_authenticated/admins/$adminId"
    | "/_authenticated/admins/new"
    | "/_authenticated/payments/$paymentId"
    | "/_authenticated/payments/new"
    | "/_authenticated/students/new"
    | "/_authenticated/teachers/new"
    | "/_authenticated/admins/"
    | "/_authenticated/payments/"
    | "/_authenticated/reports/"
    | "/_authenticated/students/"
    | "/_authenticated/teachers/"
    | "/_authenticated/students/$studentId/edit"
    | "/_authenticated/students/$studentId/profile"
    | "/_authenticated/teachers/$teacherId/edit"
    | "/_authenticated/teachers/$teacherId/profile"
    | "/_authenticated/students/$studentId/"
    | "/_authenticated/teachers/$teacherId/"
    | "/_authenticated/reports/detailed-view/monthly-student-registrations/$date"
    | "/_authenticated/reports/detailed-view/student-count-by-teacher/$teacherId"
    | "/_authenticated/reports/detailed-view/teacher-assignment-by-location/$centerId";
  fileRoutesById: FileRoutesById;
}

export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren;
  LoginRoute: typeof LoginRoute;
}

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
};

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_authenticated",
        "/login"
      ]
    },
    "/_authenticated": {
      "filePath": "_authenticated.tsx",
      "children": [
        "/_authenticated/profile",
        "/_authenticated/",
        "/_authenticated/admins/$adminId",
        "/_authenticated/admins/new",
        "/_authenticated/payments/$paymentId",
        "/_authenticated/payments/new",
        "/_authenticated/students/new",
        "/_authenticated/teachers/new",
        "/_authenticated/admins/",
        "/_authenticated/payments/",
        "/_authenticated/reports/",
        "/_authenticated/students/",
        "/_authenticated/teachers/",
        "/_authenticated/students/$studentId/edit",
        "/_authenticated/students/$studentId/profile",
        "/_authenticated/teachers/$teacherId/edit",
        "/_authenticated/teachers/$teacherId/profile",
        "/_authenticated/students/$studentId/",
        "/_authenticated/teachers/$teacherId/",
        "/_authenticated/reports/detailed-view/monthly-student-registrations/$date",
        "/_authenticated/reports/detailed-view/student-count-by-teacher/$teacherId",
        "/_authenticated/reports/detailed-view/teacher-assignment-by-location/$centerId"
      ]
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/_authenticated/profile": {
      "filePath": "_authenticated/profile.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/": {
      "filePath": "_authenticated/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/admins/$adminId": {
      "filePath": "_authenticated/admins/$adminId.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/admins/new": {
      "filePath": "_authenticated/admins/new.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/payments/$paymentId": {
      "filePath": "_authenticated/payments/$paymentId.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/payments/new": {
      "filePath": "_authenticated/payments/new.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/students/new": {
      "filePath": "_authenticated/students/new.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/teachers/new": {
      "filePath": "_authenticated/teachers/new.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/admins/": {
      "filePath": "_authenticated/admins/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/payments/": {
      "filePath": "_authenticated/payments/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/reports/": {
      "filePath": "_authenticated/reports/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/students/": {
      "filePath": "_authenticated/students/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/teachers/": {
      "filePath": "_authenticated/teachers/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/students/$studentId/edit": {
      "filePath": "_authenticated/students/$studentId/edit.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/students/$studentId/profile": {
      "filePath": "_authenticated/students/$studentId/profile.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/teachers/$teacherId/edit": {
      "filePath": "_authenticated/teachers/$teacherId/edit.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/teachers/$teacherId/profile": {
      "filePath": "_authenticated/teachers/$teacherId/profile.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/students/$studentId/": {
      "filePath": "_authenticated/students/$studentId/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/teachers/$teacherId/": {
      "filePath": "_authenticated/teachers/$teacherId/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/reports/detailed-view/monthly-student-registrations/$date": {
      "filePath": "_authenticated/reports/detailed-view/monthly-student-registrations/$date.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/reports/detailed-view/student-count-by-teacher/$teacherId": {
      "filePath": "_authenticated/reports/detailed-view/student-count-by-teacher/$teacherId.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/reports/detailed-view/teacher-assignment-by-location/$centerId": {
      "filePath": "_authenticated/reports/detailed-view/teacher-assignment-by-location/$centerId.tsx",
      "parent": "/_authenticated"
    }
  }
}
ROUTE_MANIFEST_END */
